<template>
  <div class="videos">
    <div class="top">
      <back-button></back-button>
      <help-button></help-button>
    </div>
    <div class="content">
      <h1>Video</h1>

      <vue-plyr ref="plyrinstance" :options="{fullscreen: { enabled: true }, controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen']}">
        <video :poster="videos[video].cover.url">
          <source :src="videos[video].file" type="video/mp4">
        </video>
      </vue-plyr>
      <p>{{ videos[video].title }}</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VuePlyr from 'vue-plyr'
Vue.use(VuePlyr)

export default {
  name: 'videos',
  props: {
    exhibitslug: String,
    video: { type: Number, default: 0 }
  },
  computed: {
    exhibits () {
      return this.$store.state.exhibits
    },
    exhibit () {
      return this.exhibits[this.exhibitid]
    },
    exhibitdata () {
      return this.$store.state.exhibit_data[this.exhibitid]
    },
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    },
    videos () {
      return this.exhibitdata.videos
    }
  },
  methods: {
    link (id, video) {

      return { name: 'video', params: { exhibitid: id, video: video } }
    }
  },
  watch: {
    '$route.params.video' (to, from) {
      let vidnum = parseInt(to)
      vidnum = isNaN(vidnum) ? 0 : vidnum
      this.$refs.plyrinstance.player.source = { type: 'video', sources: [this.videos[vidnum]] }
    }
  }
}
</script>

<style lang="scss">
$plyr-color-main: #444;
@import 'plyr/src/sass/plyr.scss';
.plyr--video .plyr__controls {
  padding: 5px;
}
</style>

<style lang="scss" scoped>
.videos {
  color: #000;
  height: 100%;
  overflow: hidden;
  background: url('../assets/backgrounds/heliconia.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
}
.top {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.content {
  color: #000;
  background-color: white;
  padding: 20px;
  margin: 30px;
  margin-top: 0;
  flex: 1;
  overflow: auto;
}
</style>
/
